import React from 'react';
import { DuetSpacer } from '@duetds/react/commonjs';

export default function ErrorMessage({ message }: { message: string }) {
    return <>
    <DuetSpacer size="medium"/>
    <div className="error-message">{message}</div>
    </>
}
